import { useTranslation } from 'react-i18next';
import { Row, Col, Drawer, Menu } from 'antd';
import styles from './Header.module.scss';
import IcecreamLogo from 'components/IcecreamLogo/IcecreamLogo';
import { LanguageSwitcher, ResponsiveContainer, Typography } from '@sunday/component';
import { useState } from 'react';
import { DownOutlined, MenuOutlined, UpOutlined } from '@ant-design/icons';
import { config } from '../../config';

const { ASSET_PREFIX } = config;

export const Header = ({ language }: any) => {  
  const { i18n, t } = useTranslation('header.menu');
  const [ isSubMenuVisible, setSubMenuVisible ] = useState(false);
  const [ isMobileSubMenuVisible, setMobileSubMenuVisible ] = useState(false);
  return (
    <>
      <header className={styles.header} style={{ width: '100%' }} >
        <Drawer
          placement={"top"}
          closable={false}
          onClose={() => setSubMenuVisible(false)}
          open={isSubMenuVisible}
          key={"top"}
          rootStyle={{
            top: 120,
            height: 'calc(100% - 120px)',
            zIndex: 20
          }}
          zIndex={20}
        >
          <ResponsiveContainer className={styles.drawer}>
            <a href="https://easysunday.co.id/id/product/car/">
              <Typography.Title designLevel={3} weight='bold'>
                {t('menu.products.motor')}
              </Typography.Title>
            </a>
            <a href="https://easysunday.co.id/id/product/personal/">
              <Typography.Title designLevel={3} weight='bold'>
                {t('menu.products.accident')}
              </Typography.Title>
            </a>
            <a href="/health">
              <Typography.Title designLevel={3} weight='bold'>
                {t('menu.products.health')}
              </Typography.Title>
            </a>
          </ResponsiveContainer>
        </Drawer>
        <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
          <ResponsiveContainer className={styles.container}>
            <div className={styles.left}>
              <IcecreamLogo href={'/'} />
                <div className={styles.menu}>
                    <a href="/#products">
                      <Typography.Title designLevel={3}>
                        {t("menu.products.title")}
                      </Typography.Title>
                    </a>
            
                    <a href="/partners">
                      <Typography.Title designLevel={3}>
                        {t("menu.partners")}
                      </Typography.Title>
                    </a>
                          
                    <a href="/about">
                      <Typography.Title designLevel={3}>
                        {t("menu.about")}
                      </Typography.Title>
                    </a>
            
                    <a href="/contact">
                      <Typography.Title designLevel={3}>
                        {t("menu.contact")}
                      </Typography.Title>
                    </a>
                </div>

            </div>
            <div className={styles.right}>
              <LanguageSwitcher
                availableLanguages={['en', 'id']} 
                language={language}
                onChangeLanguage={(lang) => i18n.changeLanguage(lang)} 
                hideOnMobile={true}
              />
            </div>
          </ResponsiveContainer>
        </div>
        <div className={styles.mobileContainer} >
          <IcecreamLogo href={'/'} />
          <div className={styles.right}>
            <LanguageSwitcher
              availableLanguages={['en', 'id']} 
              language={language}
              onChangeLanguage={(lang) => i18n.changeLanguage(lang)} 
              hideOnMobile={false}
            />
            <a style={{marginLeft: "24px"}} onClick={() => setMobileSubMenuVisible(!isSubMenuVisible)}>
              <span><MenuOutlined /></span>
            </a>
          </div>
          <Drawer
            placement={"right"}
            closable={false}
            onClose={() => setMobileSubMenuVisible(false)}
            open={isMobileSubMenuVisible}
            key={"right"}
          >
            <Menu selectable={false} className={styles.mobileMenu} mode="inline" inlineIndent={14}>
              {
                /*
              <Menu.SubMenu
                key="sub1"
                style={{ alignSelf: "flex-start" }}
                title={<Typography.Title designLevel={3} weight='bold'>
                  {t("menu.products.title")}
              </Typography.Title>}
              >
                <Menu.Item key="motor">
                  <a href="https://easysunday.co.id/id/product/car/">
                    <Typography.Title designLevel={3} weight='bold'>
                      {t('menu.products.motor')}
                    </Typography.Title>
                  </a>
                </Menu.Item>
                <Menu.Item key="accident">
                  <a href="https://easysunday.co.id/id/product/personal/">
                    <Typography.Title designLevel={3} weight='bold'>
                      {t('menu.products.accident')}
                    </Typography.Title>
                  </a>
                </Menu.Item>
                <Menu.Item key="health">
                  <a href="/health">
                    <Typography.Title designLevel={3} weight='bold'>
                      {t('menu.products.health')}
                    </Typography.Title>
                  </a>
                </Menu.Item>
              </Menu.SubMenu>
              */
              }
              <Menu.Item key="0">
                <a href="/#products">
                  <Typography.Title designLevel={3} weight='bold'>
                    {t("menu.products.title")}
                  </Typography.Title>
                </a>
              </Menu.Item>
              <Menu.Item key="1">
                <a href="/partners">
                  <Typography.Title designLevel={3} weight='bold'>
                    {t("menu.partners")}
                  </Typography.Title>
                </a>
              </Menu.Item>
              <Menu.Item key="4">
              <a href="/about">
                <Typography.Title designLevel={3} weight='bold'>
                  {t("menu.about")}
                </Typography.Title>
              </a>
              </Menu.Item>
              <Menu.Item key="5">
              <a href="/contact">
                <Typography.Title designLevel={3} weight='bold'>
                  {t("menu.contact")}
                </Typography.Title>
              </a>
              </Menu.Item>
              <div style={{ alignSelf: 'flex-start', marginTop: "16px",marginLeft: "20px", display: 'flex', gap: '32px', justifyContent: 'flex-start'}}>
                <a href={`tel:${t('phone')}`}>
                  <img
                    width={24}
                    height={24}
                    src={`${ASSET_PREFIX}/static/icon/ic-phone.svg`}
                    alt={'phone'}
                  />
                </a>
                <a href={`mailto:${t('email')}`}>
                  <img
                    width={24}
                    height={24}
                    src={`${ASSET_PREFIX}/static/icon/ic-mail.svg`}
                    alt={'mail'}
                  />
                </a>
              </div>
            </Menu>
          </Drawer>
        </div>
        
      </header>
    </>
  );
};